import { FC } from "react";
import { LawyerOrLawFirmStatus } from "../../model/registrationEnums";
import { isIneligibleLawFirm } from "../../eligibility/participantEligibilityRules";
import { IneligibleLawFirmNotice } from "./IneligibleLawFirmNotice";
import { IneligibleTitleNotice } from "./IneligibleTitleNotice";
import { LawyerOrLawFirmSelectField } from "./LawyerOrLawFirmSelectField";
import { LeavesOtherOnEntryField } from "./LeavesOtherOnEntryField";

type ChangeInteressentskabEnteringPartyEligibilityFieldsProps = {
  namePrefix: string;
  idPrefix: string;
  isLawyerOrLawFirm: string;
  passedPartnerExam: string;
  leavesOtherOnEntry: string;
};

const INELIGIBLE_TITLE = "Denne deltager kan ikke tilføjes.";

export const ChangeInteressentskabEnteringPartyEligibilityFields: FC<
  ChangeInteressentskabEnteringPartyEligibilityFieldsProps
> = ({
  namePrefix,
  idPrefix,
  isLawyerOrLawFirm,
  passedPartnerExam,
  leavesOtherOnEntry,
}) => (
  <div className="d-flex flex-column gap-4">
    <LawyerOrLawFirmSelectField
      namePrefix={namePrefix}
      idPrefix={idPrefix}
      label="Er deltageren advokat eller advokatselskab?"
    />
    {isIneligibleLawFirm(isLawyerOrLawFirm) && (
      <IneligibleLawFirmNotice title={INELIGIBLE_TITLE} />
    )}
    {isLawyerOrLawFirm === LawyerOrLawFirmStatus.IkkeAdvokat && (
      <IneligibleTitleNotice title={INELIGIBLE_TITLE} />
    )}
    <LeavesOtherOnEntryField
      namePrefix={namePrefix}
      idPrefix={idPrefix}
      isLawyerOrLawFirm={isLawyerOrLawFirm}
      passedPartnerExam={passedPartnerExam}
      leavesOtherOnEntry={leavesOtherOnEntry}
      label="Ophører interessentens tilknytning til en anden virksomhed samtidigt med indtræden i denne?"
      helperWhenJa="Udtræder selskabsdeltageren af en anden ejerkreds, skal pågældende selskab indsende en blanket vedrørende ændringen. Ophører en enkeltmandsvirksomhed ved nærværende ændring, skal CVR tilpasses. Læs om sluterklæringer på Advokatsamfundets hjemmeside."
    />
  </div>
);
